import parse from 'html-react-parser';
// parse --> https://github.com/remarkablemark/html-react-parser
import idString from '../../tools/stringToHtmlId';

import encodeHTMLEntities from '../../tools/encodeHTMLEntities';

export default function DocHtmlParser({ html }) {
  let tempHtml = '';

  // HTML del contenuto della pagina
  const aList = [];
  const brList = [];
  const h1List = [];
  const h2List = [];
  const h3List = [];
  const h4List = [];
  const h5List = [];
  const h6List = [];
  const imgList = [];
  const nodeList = [];
  const pList = [];
  const sectionList = [];
  let countImages = 0;

  // Voci dell'indice generato
  const tocItems = [];

  const parse_options = {
    replace: domNode => {
      nodeList.push(domNode);

      // console.log('domNode', domNode);
      // composizione stringa HTML
      if (
        (domNode.next && domNode.next.name === 'h1') ||
        (domNode.next && domNode.next.name === 'h2') ||
        (domNode.next && domNode.next.name === 'h3')
      ) {
        tempHtml = `${tempHtml}</div>`;
      }

      if (domNode && domNode.name === 'br') {
        tempHtml = `${tempHtml}`;
        return ' ';
      }

      switch (domNode.name) {
        case 'h1':
          // console.log('domNode h1', domNode);
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            let name = domNode.name;
            let id = `${idString(data)}`;
            h1List.push(data);
            tocItems.push({
              name,
              data,
              id,
            });
            tempHtml = `${tempHtml}
            <div id="${id}"
            class="capitolo">
            <a
            class="copyLink"
                title="Clicca per copiare il link negli appunti"
                href="#${id}"
                >
                <h1>
                <i class="fa fa-link"></i>
                ${data}</h1>
                <hr/>
                </a>
                `;
          }

          break;
        case 'h2':
          // console.log('domNode h2', domNode);
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            let name = domNode.name;
            let id = `${idString(data)}`;
            h2List.push(data);
            tocItems.push({
              name,
              data,
              id,
            });
            tempHtml = `${tempHtml}
                    <div id="${id}"
                    class="sottosezione">
                    <a
                class="copyLink"
                title="Clicca per copiare il link negli appunti"
                href="#${id}"
                >
                <h2>
                <i class="fa fa-link"></i>
                  ${data}</h2>
                  </a>
                  `;
          }
          break;
        case 'h3':
          //console.log('domNode <h3>', domNode);
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            let name = domNode.name;
            let id = `${idString(data)}`;
            h3List.push(data);
            tocItems.push({
              name,
              data,
              id,
            });
            tempHtml = `${tempHtml}
            <div id="${id}"
              class="sottosezione">
              <a
                class="copyLink"
                title="Clicca per copiare il link negli appunti"
                href="#${id}"
              >
                <h3>
                  <i class="fa fa-link"></i>
                  ${data}</h3>
              </a>
            `;
          }
          break;
        case 'h4':
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            h4List.push(data);
          }
          break;
        case 'h5':
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            h5List.push(data);
          }
          break;
        case 'h6':
          if (
            domNode.children[0].data ||
            domNode.children[0].children[0].data
          ) {
            let data = domNode.children[0].data
              ? domNode.children[0].data
              : domNode.children[0].children[0].data;
            h6List.push(data);
          }
          break;

        case 'p':
          pList.push(domNode);
          // console.log('domNode <p>', domNode);
          if (domNode.parent && domNode.parent.name === 'blockquote') {
            return '';
          }
          domNode.children.map((node, i) => {
            // console.log('node', node);

            if (node.data && node.data !== '') {
              tempHtml = `${tempHtml}${node.data}`;
            }
            if (node.name === 'a') {
              let href = node.attribs.href
                ? ` href="${node.attribs.href}" `
                : ` href="#" `;
              let title = node.attribs.title
                ? ` title="${node.attribs.title}" `
                : ` title="Link esterno" `;

              tempHtml = `${tempHtml}
                <a target="_blank"
                  rel="noopener noreferrer"
                  ${href} ${title}
                >${node.children[0].data}</a> `;
            }
            if (node.name === 'p') {
              tempHtml = `${tempHtml}${node.data}`;
            }
            if (node.name === 'br') {
              tempHtml = `${tempHtml} `;
            }
            if (
              (node.name === 'b' || node.name === 'strong') &&
              node.children[0].data
            ) {
              tempHtml = `${tempHtml}<b>${node.children[0].data}</b>`;
            }
            if (
              (node.name === 'i' || node.name === 'em') &&
              node.children[0].data
            ) {
              tempHtml = `${tempHtml}<em>${node.children[0].data}</em>`;
            }
            if (node.name === 'u' && node.children[0].data) {
              tempHtml = `${tempHtml}<u>${node.children[0].data}</u>`;
            }
            if (
              node.name === 'code' &&
              node.children[0].data &&
              node.children[0].data !== ''
            ) {
              tempHtml = `${tempHtml}<code>${encodeHTMLEntities(
                node.children[0].data
              )}</code>`;
            }
            return '';
          });
          break;

        case 'a':
          aList.push(domNode);
          /*
          let href = domNode.attribs.href
            ? ` href="${domNode.attribs.href}" `
            : ` href="#" `;
          let title = domNode.attribs.title
            ? ` title="${domNode.attribs.title}" `
            : ` title="Link esterno" `;

          tempHtml = `${tempHtml}
          <a target="_blank"
            rel="noopener noreferrer"
            ${href} ${title}
            >
            ${domNode.children[0].data}
          </a> `;
          */
          break;

        case 'blockquote':
          tempHtml = `${tempHtml}<blockquote>`;

          domNode.children[0].children.map((node, i) => {
            if (node.type === 'text' && node.data && node.data !== '') {
              tempHtml = `${tempHtml}${node.data}`;
            }
            return ' ';
          });
          tempHtml = `${tempHtml}</blockquote>`;
          break;

        case 'ul':
          tempHtml = `${tempHtml}<ul>`;
          domNode.children.map((node, i) => {
            if (node.name === 'li' && node.children.data !== '') {
              tempHtml = `${tempHtml}<li>${node.children[0].data}</li>`;
            }
            return '';
          });
          tempHtml = `${tempHtml}</ul>`;
          break;

        case 'ol':
          tempHtml = `${tempHtml}<ol>`;
          domNode.children.map((node, i) => {
            if (node.name === 'li' && node.children.data !== '') {
              tempHtml = `${tempHtml}<li>${node.children[0].data}</li>`;
            }
            return '';
          });
          tempHtml = `${tempHtml}</ol>`;
          break;

        case 'img':
          imgList.push(domNode);
          countImages++;
          tempHtml = `${tempHtml}
          <span class="clearfix d-block">
            <img class="img-content img-fluid"
              id="immagine-${countImages}" 
              alt="${
                domNode.attribs.alt !== ''
                  ? domNode.attribs.alt
                  : 'TS-Intelligence - immagine-' + countImages
              }"
              src="${domNode.attribs.src}"
            />
          </span>  
          `;
          break;

        case 'pre':
          //console.log('domNode <pre>', domNode);
          if (domNode.children[0].data && domNode.children[0].data !== '') {
            let data = domNode.children[0].data;
            // console.log('data in <pre>', data);
            tempHtml = `${tempHtml}<pre>${encodeHTMLEntities(data)}</pre>`;
          }
          break;

        case 'code':
          /* if (domNode.children[0].data && domNode.children[0].data !== '') {
            let data = domNode.children[0].data;
            tempHtml = `${tempHtml}<code>${encodeHTMLEntities(data)}</code>`;
          } */
          break;

        case 'section':
          sectionList.push(domNode.attribs.id);
          break;

        default:
          break;
      }
    },
  };

  parse(html, parse_options);

  tempHtml.replace(/\s\s+/g, ' ');

  if (h1List.length === 0 && (h2List.length === 0) & (h3List.length === 0)) {
    html = `
      <div id="auto-generated-content">
        <h1>HTML NON VALIDO</h1>
        <p>Non è possibile generare l'indice dei contenuti.<br>
        Non sono state trovate intestazioni di sezione (tag h1 / h2 / h3).</p>
      </div>
    `;
  } else {
    // sposto "</div>" iniziale alla fine della stringa"
    if (tempHtml.substr(0, 6) === '</div>') {
      tempHtml = tempHtml.substr(6) + tempHtml.substr(0, 6);
    } else {
      tempHtml = `<div>${tempHtml}`;
    }
    html = `<div id="auto-generated-content">${tempHtml}</div>`;
  }
  //  console.log('html', html);
  return {
    aList,
    brList,
    h1List,
    h2List,
    h3List,
    h4List,
    h5List,
    h6List,
    html,
    imgList,
    nodeList,
    pList,
    sectionList,
    tocItems,
  };
}
